import { Component, computed, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';

@Component({
  selector: 'app-chat-input',
  standalone: true,
  imports: [FormsModule, Button, InputText],
  templateUrl: './chat-input.component.html',
})
export class ChatInputComponent {
  readonly disabled = input(false);
  readonly placeholder = input('Escribe un mensaje...');

  readonly enviar = output<string>();

  readonly texto = signal('');

  readonly puedeEnviar = computed(() => !this.disabled() && this.texto().trim().length > 0);

  onEnviar(): void {
    if (!this.puedeEnviar()) {
      return;
    }
    this.enviar.emit(this.texto().trim());
    this.texto.set('');
  }
}
